import { Component, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, Params } from '@angular/router';
import { ProductSlider, ProductSlider1, ProductSlider2, ProductSlider3, ProductSlider4, ProductSlider5, ProductSlider6, ProductSlider7, ProductSlider8 } from '../../../Components/sliders/slider';
import { AppService } from 'src/app/app.service';
import { ENDPOINTS, ORG_DETAILS } from 'src/app/app.config';
import { HeaderService } from 'src/app/Components/Common/header/header-two/header.service';
import { config } from 'src/configs/config';
import { AlertsService } from 'src/app/Components/alerts/alerts.service';
import { OwlOptions } from 'ngx-owl-carousel-o/lib/models/owl-options.model';
import { CartService } from 'src/app/Lazy-loaded-Modules/Cart-module/cart-page/cart-page.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { LocalStorageService } from 'src/app/Services/auth-service/local-storage.service';
import { NewNavbarService } from 'src/app/Components/new-navbar/new-navbar.service';
import { MetadataService } from 'src/app/Services/seo_services/head_metadata.service';
import { SEO_VARIABLES } from 'src/seo/seo.config';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ViewportScroller } from '@angular/common';
import { SEOService } from 'src/app/seo.service';


@Component({
  selector: 'app-home-two',
  templateUrl: './home-two.component.html',
})
export class HomeTwoComponent implements OnInit {
  subscribeForm: FormGroup;
  validateForm: boolean = false;
  changeactive: boolean = true;
  changeactive1: boolean = false;
  imgSrc: string;
  @ViewChild("content", { static: true }) content: ElementRef;
  reviews = [{ "user": "Shanthi n Vasu", "comment": "Shubh Cards is the best destination for wedding cards, no doubt! They custom designed our card so well and at a very good price. The quality of the card was phenomenal! Everybody appreciated the card and were awe struck at the beautiful design and fantastic quality of the card and printing. Inspite of heavy rains, our cards were delivered on time. We thank Shubh Cards for the fantastic experience. Very professional people!! Thank you Shubh Cards!!" },
  { "user": "Geetha Krishna", "comment": "Great choices & lovely designs. Dilip's communication has been perfect at every stage of the invitation delivery. Time within which we had requested the cards to be delivered was met way ahead of our expectation. Everyone we have given our invitation has been saying how beautiful it is. Thank you Dilip for your help & wonderful service." },
  { "user": "Srinivasan Krishnamurthi", "comment": "I visited Shubh Cards about three weeks ago to place an order for wedding cards, and also met with Dilip Kumar who owns and runs the business. I was both impressed with the place and Dilip Kumar, a soft spoken gentleman. Dilip was very helpful and keen to help with what you want and at the same time share his knowledge and experience to bring out the best. They were prompt, accommodative and delivered a good product and service. The staff I briefly met with were also very kind and warm. I will definitely recommend Shubh Cards. Thank you for the great services." },
  { "user": "Vani Ravikumar", "comment": "We had a very happy experience with shubh cards. Mr Dhilip was very cordial and patient and all ears to our suggestions he gave his thoughts to suit our requirements. The delivery was on time and work was impeccable." },
  { "user": "Sam Rajah", "comment": "I ordered my wedding cards from Shubh Cards. The service from start to finish was perfect and the cards were tailored to my exact requirements. Also, I received cards 3 days after final payment (India to UK). Very good service and great cards!" }]

  reviews1 = [{ "user": "Deepak Bhat ", "comment": "If you need excellent quality pouches for food packaging, then this is the perfect place for you. Their business highlights include competitive pricing, quick service, and excellent quality. They also offer a wide variety of materials to suit your specific needs. Highly recommended for anyone seeking top-notch packaging solutions.", "img": "https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Deera/StoreGallery/deepak.png" },
  { "user": "Pavan kumar", "comment": "It's a delight to do business with Deepak..He is so gracious and considerate.. I have been his bulk customer for the past 2+ Years. Never disappointed with the quality and price..", "img": "https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Deera/StoreGallery/PavanKumar.png" },
  { "user": "Alexis Syngkrem", "comment": "For real they provide one of the best pouches and their customer service is top notch!!! Do give their products a try and hope you'll be satisfied with their products as I have! ", "img": "https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Deera/StoreGallery/Alexis+Syngkrem.png" },

  ]

  reviews2 = [{ "user": "Sudhakar K ", "comment": "...IT Infrastructure training from an IT company makes a lotof difference. Accel had a lot of real life scenarios in IT infrastructure management that prepared me for both the interview and the job" },
  { "user": "Mohana Krishnan", "comment": "Accel was my first choice for embedded systems training as it was well established in the domain and also highly recommended by my seniors." },
  { "user": "Chandru Dhinaharan", "comment": ".Accel was one of the few centres offering embedded systems training when I was eagerly looking forward to a technology based career option to go with my subject background in engineering." },
  ]
  customOptions: OwlOptions = {


    // navContainerClass: 'owl-nav',
    autoplay: true,
    loop: false,
    navSpeed: 220,
    autoplayHoverPause: true,
    // navClass: [ 'owl-prev', 'owl-next' ],
    navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true,
  }

  public ProductSliderConfig: any = ProductSlider;
  public ProductSliderConfig1: any = ProductSlider1;
  public ProductSliderConfig2: any = ProductSlider2;
  public ProductSliderConfig3: any = ProductSlider3;
  public ProductSliderConfig4: any = ProductSlider4;
  public ProductSliderConfig5: any = ProductSlider5;
  public ProductSliderConfig6: any = ProductSlider6;
  public ProductSliderConfig7: any = ProductSlider7;
  public ProductSliderConfig8: any = ProductSlider8;
  poloName
  poloid
  roundedPercentage
  allproducts: any;
  allproducts1: any;
  featureProductsApiData: any;
  newArrivalApiData: any;
  showalertmsg: boolean = true;
  checkoutAlerts: boolean = false;
  allCategories: any;
  getallcatsri: boolean = true;
  showAll: boolean = false;
  allCategoriesSri: any;
  SchiftOfferMessage: any;
  allCategories1: any;
  allCategories2: any;
  allCategories3: any;
  allCategorieskub: any;
  category: any
  category1: any
  categoryIcon: any
  active: any
  products;
  tazgroceries;
  tazFruits;
  carouselData: any;
  mobile_images = [];
  desk_images = [];
  homebanner1 = [];
  homebanner2 = [];
  mobilehomebanner1 = [];
  mobilehomebanner2 = [];
  tazDairy;
  ProductsbasedonCategory;
  ProductsbasedonCategory1;
  subCategory: any
  categoryName: any
  totalProducts: any = 0;
  subCategory1: any
  subCategory2: any
  public req_filter_data1;
  totalItemsOrProducts: any = 0;
  public filtersApiData;
  public totalNumberOfProducts;
  public totalLength;
  public cartData = [];
  public outletId;
  recommededProducts: any = []
  recommededProductsBestSch: any = []
  recommededProductsSchift: any = []
  recommededProductsLush: any = []
  newArrival: any = []
  newArrivalKat: any = []
  newArrivalKatMobile: any = []
  englishBook: any = []
  mathsBook: any = []
  englishBookMobile: any = [];
  mathsBookMobile: any = [];
  config = config;
  title = config.title;
  showAlerts = false;
  modalReference;
  currentPageUrl;
  req_feature_product_data: any;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };

  slides = [
    [
      { title: 'Card 1' },
      { title: 'Card 2' },
      { title: 'Card 3' },
      { title: 'Card 4' }
    ],
    [
      { title: 'Card 5' },
      { title: 'Card 6' },
      { title: 'Card 7' },
      { title: 'Card 8' }
    ]
    // Add more arrays for additional slides if needed
  ];
  featuredCollections1 = [
    {
      image: '../../assets/images/n2.png',
      title: 'category',
      subtitle: false,
      link: '/listing'
    },
    {

      image: '../../assets/images/n1.png',
      title: 'listing',
      subtitle: false,
      link: '/listing'
    },
    // {
    // 	image:  '../../assets/images/n3.png',
    // 	title: 'MEMBERS',
    //   subtitle: false,
    //   link: '/listing'
    // },
    // {
    // 	image:  '../../assets/images/n4.png',
    // 	title: 'NEWS & EVENTS',
    //   subtitle: false,
    //   link: '/listing'
    // },
  ];

  featuredCleCollections = [
    {
      image: '../../assets/images/n2.png',
      title: 'category',
      subtitle: false,
      link: '/listing'
    },
    {

      image: '../../assets/images/n1.png',
      title: 'listing',
      subtitle: false,
      link: '/listing'
    },
    {
      image: '../../assets/images/n3.png',
      title: 'MEMBERS',
      subtitle: false,
      link: '/listing'
    },
    {
      image: '../../assets/images/n4.png',
      title: 'NEWS & EVENTS',
      subtitle: false,
      link: '/listing'
    },
  ];
  featuredCollections_beaubelle = [
    {
      image: '/assets/images/beaubelle/b&b.png',
      title: 'category',
      subtitle: false,
      link: '/listing'
    },
    {

      image: '/assets/images/beaubelle/b&b.png',
      title: 'listing',
      subtitle: false,
      link: '/listing'
    },
    {
      image: '/assets/images/beaubelle/mccomestics.png',
      title: 'MEMBERS',
      subtitle: false,
      link: '/listing'
    },

  ];

  //   featuredCollections2 = [
  //     {
  //      image: '../../assets/images/n2.png',
  //      title: 'category',
  //      subtitle: false,
  //      link: '/listing'
  //    },
  //    {

  //      image:'../../assets/images/n1.png',
  //      title: 'listing',
  //      subtitle: false,
  //      link: '/listing'
  //    },
  //    {
  //      image:  '../../assets/images/n3.png',
  //      title: 'MEMBERS',
  //      subtitle: false,
  //      link: '/listing'
  //    },
  //    {
  //      image:  '../../assets/images/n4.png',
  //      title: 'NEWS & EVENTS',
  //      subtitle: false,
  //      link: '/listing'
  //    },
  //  ];


  featuredCollections2 = [
    {
      // image: 'assets/images/bombayhardware/brand/Pipes.jpg',
      image: 'assets/images/bombayhardware/button-blue-006.jpg',
      // title: 'Pipes',
      title: 'GI',
      subtitle: false,
      link: '/listing'
    },
    {
      // image: 'assets/images/bombayhardware/brand/Angles.jpg',
      image: 'assets/images/bombayhardware/button-blue-003.jpg',
      // title: 'Angles',
      title: 'GP',
      subtitle: false,
      link: '/listing'
    },
    {
      // image: 'assets/images/bombayhardware/brand/Flats.jpg',
      image: 'assets/images/bombayhardware/button-blue-004.jpg',
      title: 'RHS&SHS',
      // title: 'Flats',
      subtitle: false,
      link: '/listing'
    },
    {
      // image: 'assets/images/bombayhardware/brand/HotRolledProducts.jpg',
      image: 'assets/images/bombayhardware/button-blue-005.jpg',
      // title: 'Hot Rolled Products',
      title: 'MS',
      subtitle: false,
      link: '/listing'
    },
    {
      // image: 'assets/images/bombayhardware/brand/Channels.jpg',
      image: 'assets/images/bombayhardware/button-blue-002.jpg',
      title: 'SpiralWeilded',
      // title: 'Channels',
      subtitle: false,
      link: '/listing'
    },
    {
      // image: 'assets/images/bombayhardware/brand/Channels.jpg',
      image: 'assets/images/bombayhardware/button-blue-001.jpg',
      title: 'Seamless',
      // title: 'Channels',
      subtitle: false,
      link: '/listing'
    },
    // {
    //   image: 'assets/images/bombayhardware/brand/PipeFittings.jpg',
    //   // title: 'Pipe Fittings',
    //   subtitle: false,
    //   link: '/listing'
    // },
    // {
    //   image: 'assets/images/bombayhardware/brand/Seamed.jpg',
    //   // title: 'Seamed',
    //   subtitle: false,
    //   link: '/listing'
    // },
    // {
    //   image: 'assets/images/bombayhardware/brand/Pumps.jpg',
    //   // title: 'Pumps',
    //   subtitle: false,
    //   link: '/listing'
    // },
    // {
    //   image: 'assets/images/bombayhardware/brand/Pumps.jpg',
    //   // title: 'Pumps',
    //   subtitle: false,
    //   link: '/listing'
    // },
    // {
    //   image: 'assets/images/bombayhardware/brand/Pumps.jpg',
    //   // title: 'Pumps',
    //   subtitle: false,
    //   link: '/listing'
    // },
  ];

  featuredCollections3 = [
    {
      // image: 'assets/images/bombayhardware/brand/HotRolledProducts.jpg',
      image: 'assets/images/bombayhardware/button-blue-009.jpg',
      title: 'CPVC',
      subtitle: false,
      link: '/listing'
    },
    {
      // image: 'assets/images/bombayhardware/brand/Angles.jpg',
      image: 'assets/images/bombayhardware/button-blue-010.jpg',
      title: 'SWR',
      subtitle: false,
      link: '/listing'
    },
    {
      // image: 'assets/images/bombayhardware/brand/Pipes.jpg',
      image: 'assets/images/bombayhardware/button-blue-008.jpg',
      title: 'UPVC',
      subtitle: false,
      link: '/listing'
    },
    {
      //  image: 'assets/images/bombayhardware/brand/Flats.jpg',
      image: 'assets/images/bombayhardware/button-blue-007.jpg',
      title: 'PVC',
      subtitle: false,
      link: '/listing'
    },
  ];


  featuredCollections4 = [
    {
      image: 'assets/images/bombayhardware/brand/Pumps.jpg',
      title: 'Pumps',
      subtitle: false,
      link: '/listing'
    },
    {
      image: 'assets/images/bombayhardware/brand/Angles.jpg',
      title: 'Angles',
      subtitle: false,
      link: '/listing'
    },
    {
      image: 'assets/images/bombayhardware/brand/Flats.jpg',
      title: 'Flats',
      subtitle: false,
      link: '/listing'
    },
  ];




  featuredCollections = [{
    image: 'https://d18xkwaipu1whh.cloudfront.net/EarthyWorthyAsset/designer.jpg',
    title: 'DESIGNER',
    subtitle: false,
    link: '/listing'
  },
  {

    image: 'https://d18xkwaipu1whh.cloudfront.net/EarthyWorthyAsset/kidswear.jpg',
    title: 'KIDS WEAR',
    subtitle: false,
    link: '/listing'
  },
  {
    image: 'https://d18xkwaipu1whh.cloudfront.net/EarthyWorthyAsset/ethnic.jpg',
    title: 'ETHINIC',
    subtitle: false,
    link: '/listing'
  },
  {
    image: 'https://d18xkwaipu1whh.cloudfront.net/EarthyWorthyAsset/westernwear.jpg',
    title: 'WESTERN WEAR',
    subtitle: false,
    link: '/listing'
  },
  {
    image: 'https://d18xkwaipu1whh.cloudfront.net/EarthyWorthyAsset/winter.jpg',
    title: 'WINTER WEAR',
    subtitle: false,
    link: '/listing'
  },
  {
    image: 'https://d18xkwaipu1whh.cloudfront.net/EarthyWorthyAsset/T-shirt.jpg',
    title: 'T-shirt',
    subtitle: false,
    link: '/listing'
  },
  ];
  featuredCollectionsBBold = [{
    image: 'https://d18xkwaipu1whh.cloudfront.net/EarthyWorthyAsset/designer.jpg',
    title: 'Bras',
    subtitle: false,
    link: '/listing'
  },
  {

    image: 'https://d18xkwaipu1whh.cloudfront.net/EarthyWorthyAsset/kidswear.jpg',
    title: 'Panties',
    subtitle: false,
    link: '/listing'
  },
  {
    image: 'https://d18xkwaipu1whh.cloudfront.net/EarthyWorthyAsset/ethnic.jpg',
    title: 'Nightwears',
    subtitle: false,
    link: '/listing'
  },
  ];

  featuredCollectionsLuckme = [{
    image: 'https://d18xkwaipu1whh.cloudfront.net/LuckMeAsset/heritage.jpg',
    title: 'Heritage',
    subtitle: false,
    link: '/listing'
  },
  {

    image: 'https://d18xkwaipu1whh.cloudfront.net/LuckMeAsset/sauce.jpg',
    title: 'Heinz',
    subtitle: false,
    link: '/listing'
  },
  {
    image: 'https://d18xkwaipu1whh.cloudfront.net/LuckMeAsset/maggi.jpg',
    title: 'MAGGI',
    subtitle: false,
    link: '/listing'
  },
  {
    image: 'assets/images/luckme/brands/nesacafe.jfif',
    title: 'NESCAFE GOLD',
    subtitle: false,
    link: '/listing'
  },
  {
    image: 'https://d18xkwaipu1whh.cloudfront.net/LuckMeAsset/colgate.jpg',
    title: 'COLGATE',
    subtitle: false,
    link: '/listing'
  },
  {
    image: 'https://d18xkwaipu1whh.cloudfront.net/LuckMeAsset/torku.jpg',
    title: 'CARAFEST',
    subtitle: false,
    link: '/listing'
  },
  ];
  featuredCollectionsKarupattiraja: any = [];

  featuredCollectionsShubhCards = [
    {
      image: 'https://d18xkwaipu1whh.cloudfront.net/Shubhcards/Common/shubhcards3.jpg',
      title: 'Classic',
      subtitle: false,
      link: '/listing'
    },
    {
      image: 'https://d18xkwaipu1whh.cloudfront.net/Shubhcards/Common/shubhcards4.jpg',
      title: 'Elite',
      subtitle: false,
      link: '/listing'
    },
    {
      image: 'https://d18xkwaipu1whh.cloudfront.net/Shubhcards/Common/shubhcards2.jpg',
      title: 'Luxury',
      subtitle: false,
      link: '/listing'
    },
    {

      image: 'https://d18xkwaipu1whh.cloudfront.net/Shubhcards/Common/shubhcards1.jpg',
      title: 'Premium',
      subtitle: false,
      link: '/listing'
    }


  ];

  featuredCollectionsDeera = [
    {
      image: 'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Shubhcards/Common/Bakeware.png',
      title: 'Baking',
      subtitle: false,
      link: '/listing'
    },
    {
      image: 'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Shubhcards/Common/Disposable+Wooden+Cutlery.png',
      title: 'Disposable Cutlery',
      subtitle: false,
      link: '/listing'
    },
    {

      // image:'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Shubhcards/Common/Smart+Packaging.png',
      image: 'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Shubhcards/Common/Stand+up+%26+Ziplock+Pouches.png',
      title: 'Packaging',
      subtitle: false,
      link: '/listing'
    },
    {
      image: 'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Shubhcards/Common/Rippled.png',
      // image:  'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Shubhcards/Common/Stand+up+%26+Ziplock+Pouches.png',
      title: 'Dining Disposable',
      subtitle: false,
      link: '/listing'
    },


  ];
  featuredCollectionsCarience = [
    {
      image: 'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Carience/Product/1700196544226%20-%20red%201.png',
      title: 'Spring Mattress',
      subtitle: false,
      link: '/listing'
    },
    {
      image: 'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Carience/Product/1706709699018%20-%20white1.jpeg',
      title: 'Foam Mattress',
      subtitle: false,
      link: '/listing'
    }

  ];

  featuredAvonProductsCollection = [
    {
      image: 'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/AvonSeals/StoreGallery/01+copy.jpg',
      title: '',
    },
    {
      image: 'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/AvonSeals/StoreGallery/02+copy.jpg',
      title: '',
    },
    {
      image: 'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/AvonSeals/StoreGallery/03+copy.jpg',
      title: '',
    },
    {
      image: 'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/AvonSeals/StoreGallery/04+copy.jpg',
      title: '',
    },
    {
      image: 'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/AvonSeals/StoreGallery/05+copy.jpg',
      title: '',
    },
    {
      image: 'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/AvonSeals/StoreGallery/06+copy.jpg',
      title: '',
    },
    {
      image: 'https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/AvonSeals/StoreGallery/07+copy.jpg',
      title: '',
    }

  ];


  featuredSchiftProductsCollection = [
    {
      image: '../../../../assets/images/schift/Categories-image-1.png',
      title: 'Skin Care',
    },
    {
      image: '../../../../assets/images/schift/Categories-image-2.png',
      title: 'UV Care',
    },
    {
      image: '../../../../assets/images/schift/Categories-image-3.png',
      title: 'Anti Aging Care',
    },
    {
      image: '../../../../assets/images/schift/sportCare.jpg',
      title: 'Sports Care',
    },
    {
      image: '../../../../assets/images/schift/TravelCare.jpg',
      title: 'Travel Care',
    },
    {
      image: '../../../../assets/images/schift/Categories-image-6.png',
      title: 'Hair Care',
    },
    {
      image: '../../../../assets/images/schift/Categories-image-7.png',
      title: 'Eye Care',
    }

  ];
  // recommededProducts = [
  //   {
  //     name: '1U3352 Unik Teeth Yellow ITR',
  //     price: '3,648',
  //     image: 'assets/images/product-1.png',
  //     link: '/listing'
  //   },
  //   {
  //     name: 'Breaker Parts ITR',
  //     price: '2,620',
  //     image: 'assets/images/product-2.png',
  //     link: '/listing'
  //   },
  //   {
  //     name: 'OTR Pattern-Siteking-HD',
  //     price: '3,900',
  //     image: 'assets/images/product-3.png',
  //     link: '/listing'
  //   },
  //   {
  //     name: 'Breaker Parts ITR',
  //     price: '2,620',
  //     image: 'assets/images/product-2.png',
  //     link: '/listing'
  //   }, {
  //     name: '1U3352 Unik Teeth Yellow ITR',
  //     price: '3,648',
  //     image: 'assets/images/product-1.png',
  //     link: '/listing'
  //   },
  //   {
  //     name: 'OTR Pattern-Siteking-HD',
  //     price: '3,900',
  //     image: 'assets/images/product-3.png',
  //     link: '/listing'
  //   },
  // ]
  constructor(
    public appService: AppService,
    private headerService: HeaderService,
    private alertService: AlertsService,
    private router: Router,
    private cartService: CartService,
    private formbuilder: FormBuilder,
    private route: ActivatedRoute,
    private localService: LocalStorageService,
    private newNavbarService: NewNavbarService,
    private metadataService: MetadataService,
    private modalService: NgbModal,
    private viewportScroller: ViewportScroller,
    private seoService: SEOService
  ) {


    this.metadataService.configureMetadata(SEO_VARIABLES.HOME.DESCRIPTION, SEO_VARIABLES.HOME.KEYWORDS, SEO_VARIABLES.HOME.TITLE)

  }
  ngOnInit(): void {
    const currentUrl = window.location.href;
    // const currentUrl = window.location.href;
    // Check if the URL contains a hash

    if (this.config.title === "PaulCaroline") {
    this.getPaulround();
    }
    if (this.config.title !== "Schift Cosmetics") {
      localStorage.removeItem('previousUrl');
    }
    if (currentUrl.includes('#')) {
      // Remove the '#' from the URL
      const newUrl = currentUrl.replace('/#', '');
      window.history.replaceState(null, '', newUrl);
      this.router.navigate[newUrl];
      location.reload();
      console.log(newUrl, "newUrl")// Navigate to the new URL without '#'
    }
    this.currentPageUrl = this.getCurrentURL()
    this.seoService.updateCanonicalUrl(this.currentPageUrl);
    this.getCarouseldetails();
    this.subscribeForm = new FormGroup({
      email: this.formbuilder.control('', [Validators.required, Validators.maxLength(50), Validators.email, Validators.pattern("^[a-z0-9+_.-]+@[a-z0-9]+[.][a-z+]+$")]),
    })
    this.subscribeForm.controls.email.setValue('');

    if (document.getElementsByClassName('modal-backdrop')[0]) {

      document.getElementsByClassName('modal-backdrop')[0].remove()

    }
    document.documentElement.scrollTop = 0;
    this.headerService.updateAdminFormEvent('clearSearchTerm');

    this.outletId = this.appService.outletId;
    console.log("this.appService.outletIdfffffffffffffff" + this.appService.outletId)
    if (this.outletId == 1) {
      this.outletId = this.localService.get('karupattirajaOutletId');
    }
    if (this.config.title == "Karupattiraja") {
      if (this.outletId == "0" || this.outletId == 0 || this.outletId == "" || this.outletId == null) {
        this.outletId = 1;
      }

    }
    this.cartService.updateCartItem(this.appService.cartProducts.results)
    if (config.title !== 'BombayHardware' && config.title !== 'Deera') {
      this.getFilterByProduct1();
    }
    console.log("ffffffffffffffffffffffffff")
    // this.topFunction() 
    this.getAllProducts();
    if (config.title == 'Kubendran') {
      this.getFilterByProductkub(this.category);
    }
    if (config.title == 'Taazah') {
      this.getFilterByProductTazGrose(),
        this.getFilterByProductTazFruit(),
        this.getFilterByProductTazDairy()
    }
    if (this.config.title == 'Vimpro') {
      this.getCategory("Vacuum Forming")
    }

    if (this.config.title === 'Karupattiraja') {

      this.modalReference = this.modalService.open(this.content);

    }
   

    if (this.config.title === "Cle") {
      this.newNavbarService.updateAdminFormEvent({ name: "categoryData" });
    }

    console.log("schift test for feature")
    // GET THE FEATURE PRODUCTS change
    if(this.config.title == 'Schift Cosmetics' || this.config.title == 'SriSenbaga' || this.config.title == 'HOB' || this.config.title == 'BombayHardware' || this.config.title == 'LushNGreen'){
      this.req_feature_product_data = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        // "outlet_id":Number(this.outletId),

        "extras": {
          "find": {

          },
          "pagination": true,
          "paginationDetails": {
            "limit": 1,
            "pagesize": 300
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "name",
            "sortorder": -1
          }
        }
      }
    } else {
      this.req_feature_product_data = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "outlet_id": Number(this.outletId),
        // "outlet_id":"",
        "extras": {
          "find": {

          },
          "pagination": true,
          "paginationDetails": {
            "limit": 1,
            "pagesize": 300
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "name",
            "sortorder": -1
          }
        }
      }
    }

    this.appService.postApiCall(this.req_feature_product_data, ENDPOINTS.GET_FEATURED_PRODUCTS).subscribe(
      resp => {

        this.featureProductsApiData = resp;
        this.recommededProducts = this.featureProductsApiData.result.data;
        console.log("recommededProducts",this.recommededProducts)
        if(config.title==='HOB'){
          const originalValue = this.recommededProducts.pricing.raw.price;
          const newValue = this.recommededProducts.pricing.raw.msrp;
          const percentageIncrease = ((newValue - originalValue) / originalValue) * 100;
          
          this.roundedPercentage = Math.round(percentageIncrease);
          console.log("percentage of the price",this.roundedPercentage)
        }
        this.recommededProductsBestSch = this.featureProductsApiData.result.data.slice(0, 4);
        this.recommededProductsSchift = this.featureProductsApiData.result.data.slice(0, 5);
        this.recommededProductsLush = this.featureProductsApiData.result.data.slice(0, 8);
        console.log("schift test for feature2")
        // if(this.recommededProducts.length > 0){
        //   if(this.recommededProducts.length > 0 && this.recommededProducts.length < 3){
        //     if(this.recommededProducts.length === 1){
        //       this.recommededProducts.push("");
        //       this.recommededProducts.push("");
        //     }
        //     else if(this.recommededProducts.length === 2){
        //       this.recommededProducts.push("");
        //     }
        //   }
        // }
        console.log(this.recommededProducts, "avon pro")
      },
      err => {
        if (err.error.error.message) {
          console.log(err.error.error.message)
        }
        else {
          console.log('Something bad happened; Please try again!')
        }
      })

    // GET THE New Arrivals
    var req_new_arrival_data = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": null,
      "extras": {
        "find": {
        },
        "pagination": true,
        "paginationDetails": {
          "limit": 1,
          "pagesize": 300
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "id",
          "sortorder": -1
        }
      }
    }
    this.appService.postApiCall(req_new_arrival_data, ENDPOINTS.GET_NEW_ARRIVAL).subscribe(
      resp => {
        console.log("schift test for feature1")
        this.newArrivalApiData = resp;
        this.newArrival = this.newArrivalApiData.result.data;
        this.newArrivalKat = this.newArrivalApiData.result.data.slice(0, 5);
        this.newArrivalKatMobile = this.newArrivalApiData.result.data.slice(0, 4);
        console.log(this.newArrivalKat)
        // if(this.recommededProducts.length > 0){
        //   if(this.recommededProducts.length > 0 && this.recommededProducts.length < 3){
        //     if(this.recommededProducts.length === 1){
        //       this.recommededProducts.push("");
        //       this.recommededProducts.push("");
        //     }
        //     else if(this.recommededProducts.length === 2){
        //       this.recommededProducts.push("");
        //     }
        //   }
        // }
        console.log(this.newArrival, "newArrival")
      },
      err => {
        if (err.error.error.message) {
          console.log(err.error.error.message)
        }
        else {
          console.log('Something bad happened; Please try again!')
        }
      })
    if (config.title == 'SriSenbaga' || config.title == 'HOB' || config.title == 'UrbanBox') {
      let reqData = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        // "outlet_id":"",
        "extras": {
          "find": {
            //  "outlet_id":this.outletId,
          },
          "pagination": false,
          "paginationDetails": {
            "limit": 1,
            "pagesize": 25
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "sort_order",
            "sortorder": -1
          }
        }
      }
      this.appService.postApiCall(reqData, ENDPOINTS.GET_ALLCATEGORIES).subscribe(
        resp => {
          this.allCategories = resp.result.data;
          this.allCategories2 = this.allCategories.slice(0, 5);
          this.allCategories3 = this.allCategories;
          this.allCategoriesSri = this.allCategories.slice(0, 4);
          console.log("allCategoriesSri", this.allCategoriesSri, this.allCategories)
          if (config.title == 'Karupattiraja') {
            this.allCategories.forEach(element => {
              // if(!element.name.toLowerCase().includes('others'))
              // {
              this.featuredCollectionsKarupattiraja.push({
                image: element.image,
                title: element.name,
                subtitle: false,
                link: '/listing'
              });
              //}

            })


          }


        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
    else {
      let reqData = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "outlet_id": Number(this.outletId),
        // "outlet_id":"",
        "extras": {
          "find": {
            //  "outlet_id":this.outletId,
          },
          "pagination": false,
          "paginationDetails": {
            "limit": 1,
            "pagesize": 25
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "sort_order",
            "sortorder": -1
          }
        }
      }
      this.appService.postApiCall(reqData, ENDPOINTS.GET_ALLCATEGORIES).subscribe(
        resp => {
          if (config.title == 'Mayan') {
            this.allCategories = this.sortByKey(resp.result.data, 'name');
          }
          else {
            this.allCategories = resp.result.data;
            this.allCategories2 = this.allCategories.slice(0, 5);
            this.allCategories3 = this.allCategories;
            this.allCategoriesSri = this.allCategories.slice(0, 4);
            console.log("allCategoriesSri", this.allCategoriesSri, this.allCategories)
            if (config.title == 'Karupattiraja') {
              this.allCategories.forEach(element => {
                // if(!element.name.toLowerCase().includes('others'))
                // {
                this.featuredCollectionsKarupattiraja.push({
                  image: element.image,
                  title: element.name,
                  subtitle: false,
                  link: '/listing'
                });
                //}

              })


            }
            if (config.title == 'Kubendran') {
              this.allCategorieskub = this.allCategories.filter(element => element.name.toLowerCase() == 'vegetables' ||
                element.name.toLowerCase() == 'fruits');
              this.getFilterByProductkub(this.allCategorieskub[0].name);
            }


          }

        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
    console.log("ffffffffffffffffffffffffff")



    // if (config.title == 'Deera') {
    //   this.getCategory2();
    //   this.getCategory1();

    // }



    if (this.config.title == "KatbookStore") {
      this.getSubjectEnglish("General English");
      this.getSubjectEnglish("Mathematics");

    }


  }
  get f() { return this.subscribeForm.controls; }
  ngAfterviewChecked() {
    this.getAllProducts
  }

      

  
  sortByKey(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];

      if (typeof x == "string") {
        x = ("" + x).toLowerCase();
      }
      if (typeof y == "string") {
        y = ("" + y).toLowerCase();
      }

      return ((x > y) ? -1 : ((x < y) ? 1 : 0));
    });
  }
  getAllProducts() {
    if (this.config.title == 'Vimpro') {
      let product_data = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {},
          pagination: true,
          paginationDetails: {
            //limit: event,
            pagesize: 25,

          },
          sorting: true,
          sortingDetails: {
            sortfield: "name",
            sortorder: +1,
          },
          subcategoryfilter: false,
        },
      };
      this.appService
        .postApiCall(product_data, ENDPOINTS.GET_ALL_PRODUCTS)
        .subscribe(
          (resp) => {
            this.allproducts = resp.result.data
          })


    }
    else {
      let product_data = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        "outlet_id": Number(this.outletId),
        // outlet_id:"",
        extras: {
          find: {

          },
          pagination: true,
          paginationDetails: {
            // limit: event,
            pagesize: 25,

          },
          sorting: true,
          sortingDetails: {
            sortfield: "name",
            sortorder: +1,
          },
          subcategoryfilter: false,
        },
      };
      if (this.config.title !== 'Vistas') {
        this.appService
          .postApiCall(product_data, ENDPOINTS.GET_ALL_PRODUCTS)
          .subscribe(
            (resp) => {
              this.allproducts = resp.result.data
            })
      }
    }





  }
  getAllCatSri() {
    this.getallcatsri = false;
    this.showAll = true;
    let reqData = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": null,
      // "outlet_id":"",
      "extras": {
        "find": {
          //  "outlet_id":this.outletId,
        },
        "pagination": false,
        "paginationDetails": {
          "limit": 1
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "sort_order",
          "sortorder": -1
        }
      }
    }
    console.log("ffffffffffffffffffffffffff")
    this.appService.postApiCall(reqData, ENDPOINTS.GET_ALLCATEGORIES).subscribe(
      resp => {
        this.allCategoriesSri = resp.result.data
      }
    )
  }

  viewLessSri() {
    this.showAll = false;
    this.getallcatsri = true;
    this.allCategoriesSri = this.allCategories.slice(0, 4);

  }
  productsListkat() {
    if (this.config.title != "SriSenbaga") {
      document.getElementById("mySidenav").style.width = "0";
    }
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });

  }
  productsListNewarrival() {
    document.getElementById("mySidenav").style.width = "0";
    this.router.navigate([`/productListing-newarrival`], { queryParams: { terms: [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });

  }
  navigateToSubject() {

    // document.getElementById("mySidenav").style.width = "0";
    // this.router.navigate([`/productListing`], {queryParams: { terms:[[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], ["General English"], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });


  }
  navigateToMaths() {

    // document.getElementById("mySidenav").style.width = "0";
    // this.router.navigate([`/productListing`], {queryParams: { terms:[[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[],[]], type:'combine' }, relativeTo:this.route,  skipLocationChange: false });
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], ["Mathematics"], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });


  }
  productsListSchift(category) {
    document.getElementById("mySidenav").style.width = "0";
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [category], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });

  }
  productsListTaz(category) {
    document.getElementById("mySidenav").style.width = "0";
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [category], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, fragment: 'targetSection', relativeTo: this.route, skipLocationChange: false });

  }
  productsListHOB(category) {
    // this.router.navigate(['/productListing'], {
    //   queryParams: {
    //     terms: [[], [category], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
    //     type: 'combine'
    //   },
    //   relativeTo: this.route,
    //   skipLocationChange: false
    // })
    console.log("Category to redirect",category)
    const params = category.split('/').map(param => param.replace(/\s+/g, '-'));
    console.log("URL BBJAH", params)
    this.router.navigate(['/productListing', ...params]).then(() => {
      this.scrollToSection();
    });
  }
productListingPaul(category){
  // this.router.navigate(['/productListing'], {
  //   queryParams: {
  //     terms: [[], [category], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
  //     type: 'combine'
  //   },
  //   relativeTo: this.route,
  //   skipLocationChange: false
  // })
  console.log("Category to redirect",category)
    const params = category.split('/').map(param => param.replace(/\s+/g, '-'));
    console.log("URL BBJAH", params)
    this.router.navigate(['/productListing', ...params]).then(() => {
    this.scrollToSection();
  });
}
productsListLush(category){
  this.router.navigate(['/productListing'], {
    queryParams: {
      terms: [[], [category], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
      type: 'combine'
    },
    relativeTo: this.route,
    skipLocationChange: false
  }).then(() => {
    this.scrollToSection();
  });
}
scrollToSection(fragment: string = 'targetSection') {
  const targetElement = document.getElementById(fragment);
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: 'smooth' });
  } else {
    console.log(`${fragment} not found, retrying...`);
    setTimeout(() => {
      this.scrollToSection(fragment);
    }, 500);
  }
}
  getFilterByProduct(category) {
    this.active = category.name;
    {
      this.req_filter_data1 = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "extras": {
          "find": {
            "brand": [],
            "category": [category.name],
            "theme": [],
            "finish": [],
            "feature": [],
            "price": [],
            "size": [],
            "thickness": [],
            "color": [],
            "type": [],
            "product_material": [],

            "last90days": false,
            "last30days": false,
            "includeoutofstock": false,
          },
          "pagination": true,
          "paginationDetails": {
            "limit": 0,
            "pagesize": 77
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "name",
            "sortorder": -1
          },
          "subcategoryfilter": false
        }


      }


      this.appService.postApiCall(this.req_filter_data1, ENDPOINTS.GET_FILTER_PRODUCTS).subscribe(
        resp => {
          this.filtersApiData = resp;
          this.products = this.filtersApiData.result.data;
          this.totalNumberOfProducts = this.filtersApiData.result.total;
          if (this.config.title === "Schift Cosmetics") {
            for (let k = 0; k < resp.result.data.length; k++) {
              if (resp.result.data[k].discounts_text) {
                if (resp.result.data[k].discounts_text.length > 0
                ) {
                  let offerBanner =
                    resp.result.data[k].discounts_text[0].product_card_view_promotion.replace(
                      /\\n/g,
                      ""
                    );
                  this.SchiftOfferMessage = offerBanner.replace(/\\s/g, "");
                  console.log("Offer Text", this.SchiftOfferMessage)
                }
              }
            }
          }
          //  if(!this.isfilter)
          //  {
          //this.isfilter=true;

          this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;

          this.totalProducts = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;
          //  this.totalLength = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;

          this.totalLength = this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;


        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
  }
  getFilterByProductTazGrose() {

    {
      this.req_filter_data1 = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "extras": {
          "find": {
            "brand": [],
            "category": ['Groceries'],
            "theme": [],
            "finish": [],
            "feature": [],
            "price": [],
            "size": [],
            "thickness": [],
            "color": [],
            "type": [],
            "product_material": [],

            "last90days": false,
            "last30days": false,
            "includeoutofstock": false,
          },
          "pagination": true,
          "paginationDetails": {
            "limit": 0,
            "pagesize": 77
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "name",
            "sortorder": -1
          },
          "subcategoryfilter": false
        }


      }


      this.appService.postApiCall(this.req_filter_data1, ENDPOINTS.GET_FILTER_PRODUCTS).subscribe(
        resp => {
          this.filtersApiData = resp;
          this.tazgroceries = this.filtersApiData.result.data;
          this.totalNumberOfProducts = this.filtersApiData.result.total;
          //  if(!this.isfilter)
          //  {
          //this.isfilter=true;

          this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;

          this.totalProducts = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;
          //  this.totalLength = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;

          this.totalLength = this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;


        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
  }
  getFilterByProductTazFruit() {

    {
      this.req_filter_data1 = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "extras": {
          "find": {
            "brand": [],
            "category": ['Fruits & Vegetables'],
            "theme": [],
            "finish": [],
            "feature": [],
            "price": [],
            "size": [],
            "thickness": [],
            "color": [],
            "type": [],
            "product_material": [],

            "last90days": false,
            "last30days": false,
            "includeoutofstock": false,
          },
          "pagination": true,
          "paginationDetails": {
            "limit": 0,
            "pagesize": 77
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "name",
            "sortorder": -1
          },
          "subcategoryfilter": false
        }


      }


      this.appService.postApiCall(this.req_filter_data1, ENDPOINTS.GET_FILTER_PRODUCTS).subscribe(
        resp => {
          this.filtersApiData = resp;
          this.tazFruits = this.filtersApiData.result.data;
          this.totalNumberOfProducts = this.filtersApiData.result.total;
          //  if(!this.isfilter)
          //  {
          //this.isfilter=true;

          this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;

          this.totalProducts = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;
          //  this.totalLength = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;

          this.totalLength = this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;


        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
  }
  getFilterByProductTazDairy() {

    {
      this.req_filter_data1 = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "extras": {
          "find": {
            "brand": [],
            "category": ['Dairy Products'],
            "theme": [],
            "finish": [],
            "feature": [],
            "price": [],
            "size": [],
            "thickness": [],
            "color": [],
            "type": [],
            "product_material": [],

            "last90days": false,
            "last30days": false,
            "includeoutofstock": false,
          },
          "pagination": true,
          "paginationDetails": {
            "limit": 0,
            "pagesize": 77
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "name",
            "sortorder": -1
          },
          "subcategoryfilter": false
        }


      }


      this.appService.postApiCall(this.req_filter_data1, ENDPOINTS.GET_FILTER_PRODUCTS).subscribe(
        resp => {
          this.filtersApiData = resp;
          this.tazDairy = this.filtersApiData.result.data;
          this.totalNumberOfProducts = this.filtersApiData.result.total;
          //  if(!this.isfilter)
          //  {
          //this.isfilter=true;

          this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;

          this.totalProducts = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;
          //  this.totalLength = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;

          this.totalLength = this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;


        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
  }
  getFilterByProductkub(category) {
    {
      this.req_filter_data1 = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "extras": {
          "find": {
            "brand": [],
            "category": [category],
            "theme": [],
            "finish": [],
            "feature": [],
            "price": [],
            "size": [],
            "thickness": [],
            "color": [],
            "type": [],
            "product_material": [],

            "last90days": false,
            "last30days": false,
            "includeoutofstock": false,
          },
          "pagination": true,
          "paginationDetails": {
            "limit": 0,
            "pagesize": 77
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "name",
            "sortorder": -1
          },
          "subcategoryfilter": false
        }


      }


      this.appService.postApiCall(this.req_filter_data1, ENDPOINTS.GET_FILTER_PRODUCTS).subscribe(
        resp => {
          this.filtersApiData = resp;
          this.products = this.filtersApiData.result.data;
          this.totalNumberOfProducts = this.filtersApiData.result.total;
          //  if(!this.isfilter)
          //  {
          //this.isfilter=true;

          this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;

          this.totalProducts = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;
          //  this.totalLength = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;

          this.totalLength = this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;


        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
  }
  getFilterByProduct1() {
    console.log(this.outletId, "this.outletIdtrduytqudgiusdhisdiouQWUDOQWIEOPQW")
    {
      this.req_filter_data1 = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "outlet_id": Number(this.outletId),
        // "outlet_id":"",
        "extras": {
          "find": {
            "brand": [],
            "category": [],
            "theme": [],
            "finish": [],
            "feature": [],
            "price": [],
            "size": [],
            "thickness": [],
            "color": [],
            "type": [],
            "product_material": [],

            "last90days": false,
            "last30days": false,
            "includeoutofstock": false,
          },
          "pagination": true,
          "paginationDetails": {
            "limit": 0,
            "pagesize": 77
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "name",
            "sortorder": -1
          },
          "subcategoryfilter": false
        }


      }


      this.appService.postApiCall(this.req_filter_data1, ENDPOINTS.GET_FILTER_PRODUCTS).subscribe(
        resp => {
          this.filtersApiData = resp;
          this.products = this.filtersApiData.result.data;
          this.totalNumberOfProducts = this.filtersApiData.result.total;
          //  if(!this.isfilter)
          //  {
          //this.isfilter=true;

          this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;

          this.totalProducts = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;
          //  this.totalLength = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;

          this.totalLength = this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;


        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
  }

  addToCart(item) {
    this.cartService.addToCart(item);
    for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
      this.cartData.push(this.appService.cartProducts.results[i].product_id);
    }
  }

  increaseItem(index) {
    this.alertService.clear();
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0

    let increment;
    tempArray.forEach((item) => {
      cartQty += item.quantity;

    })


    if (this.config.name === 'ShubhCards') {

      tempArray[index].quantity = (Number(tempArray[index].quantity) + tempArray[index].product.pricing.raw.incrementvalue)
    }
    else {
      if (Number(this.localService.get('max_cart_qty')) <= cartQty) {
        this.showAlerts = true;
        window.scrollTo(0, 0);
        this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
        return
      }
      tempArray[index].quantity = (Number(tempArray[index].quantity) + 1)
    }

    //tempArray[index].quantity = (Number(tempArray[index].quantity) + 2)
    tempArray[index].sub_total = (Number(tempArray[index].quantity) * Number(tempArray[index].cost))
    this.appService.cartProducts.results = tempArray;
    this.appService.totalCartItems = this.cartService.totalCartItems();
    console.log("ddd")
    this.cartService.updateCartItem(this.appService.cartProducts.results);
  }

  decreaseItem(index) {
    let tempArray = this.appService.cartProducts.results;
    if (this.config.name === 'ShubhCards') {
      //let tempArray = this.appService.cartProducts.results;
      if (this.appService.cartProducts.results[index].quantity - tempArray[index].product.pricing.raw.decrementvalue < tempArray[index].product.pricing.raw.minimumorderquantity) {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(this.appService.cartProducts.results[i].product_id);
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        this.showAlerts = true;
        return
      }
      tempArray[index].quantity = (Number(tempArray[index].quantity) - tempArray[index].product.pricing.raw.decrementvalue)
      tempArray[index].sub_total = (Number(tempArray[index].quantity) * Number(tempArray[index].cost))
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);

    }
    else {
      if (this.appService.cartProducts.results[index].quantity === 1) {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(this.appService.cartProducts.results[i].product_id);
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        console.log("fff")
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        return
      }
      tempArray[index].quantity = (Number(tempArray[index].quantity) - 1)
      tempArray[index].sub_total = (Number(tempArray[index].quantity) * Number(tempArray[index].cost))
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      console.log("ggg")
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    }
  }
  calculatePercentageIncrease(msrp: number, price: number): number | string {
    if (price > 0) {
      return Math.round(((msrp - price) / price) * 100);
    } else {
      return 'Invalid price data';
    }
  }
  sendProductDetails(id) {
    if (this.config.title === "Aiema" || this.config.title === "Cle") {
      this.router.navigate(['/company-details1', id], { relativeTo: this.route, skipLocationChange: false })
    }
    else {
      this.router.navigate(['/product-details', id], { relativeTo: this.route, skipLocationChange: false })
    }
  }
  buyNow(product) {
    let maxorderedquantity = this.appService.cartProducts.results.reduce((partialSum, a) => partialSum + a.quantity, 0)
    if (maxorderedquantity >= Number(this.localService.get('max_cart_qty'))) {
      this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
      return false;
    } else {
      let tempArray = this.appService.cartProducts.results;
      let cartQty = 0;

      tempArray.forEach((item) => {
        cartQty += item.quantity;
      });

      if (this.config.title === "Taazah" && product.product_type == "Simple") {
        console.log("testforcartyou")
        this.cartService.addToCart(product);
        this.router.navigate(["/checkout-new"]);
        window.scrollTo(0, 0);
      }
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(this.appService.cartProducts.results[i].product_id);
      }


    }

  }
  productDetails(id?: number, categoryPath?: string, uniqueName?: string) {
    if (this.config.title === 'Aiema' || this.config.title === 'Cle') {
      this.router.navigate(['/company-details1', id], { relativeTo: this.route, skipLocationChange: false })
    }
    // new changes for SEO 30-08-2024

    else if (this.config.title === "Deera" || this.config.title === "SriSenbaga" || this.config.title === "Taazah" || this.config.title === "LushNGreen" || this.config.title === "Srimaware" || this.config.title === "HOB" || this.config.title === "PaulCaroline") {
      categoryPath = categoryPath.replace('/', '');
      categoryPath = categoryPath.replace(/ /g, '-');
      uniqueName = uniqueName.replace(/ /g, '-');
      uniqueName = uniqueName.replace(/\(|\)/g, '');
      console.log("111", categoryPath, uniqueName);
      const params = categoryPath.split('/');
      params.push(uniqueName);

      this.router.navigate(['/product', ...params]);

    }
    else if (this.config.title === "Schift Cosmetics") {
      console.log("ppppppppplllllllllllll")
      categoryPath = categoryPath.replace('/', '');
      categoryPath = categoryPath.replace(/ /g, '-');
      uniqueName = uniqueName.replace(/ /g, '-');
      uniqueName = uniqueName.replace(/\(|\)/g, '');
      console.log("111", categoryPath, uniqueName);
      const params = categoryPath.split('/');
      params.push(uniqueName);

      this.router.navigate(['/product', ...params]);

    }
    else {
      this.router.navigate(['/product-details', id], { relativeTo: this.route, skipLocationChange: false })
    }

  }
  productDetailsPolo(id, cid) {
    this.router.navigate([`product-details/${this.poloid}/${id}`])
  }
  goto() {
    this.router.navigate(['/about-us'])
  }
  productList() {
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });
  }
  routeToCategory(route) {
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [route], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });
  }
  routeToSize(route) {
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [], [], [], [], [], [], [route], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });
  }
  vimproToCategory() {
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });
  }

  routeToList(category) {
    let cate = category.name;
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [cate], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });
  }
  routeToListbaby(category) {
    // let cate= category.name;  
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [category], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });
  }
  routeToListshub(category) {
    console.log("func called", category)
    // let cate= category.name;  
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [category], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false }).then(() => {
      // this.scrollToBottom()
      if (this.config.title == 'ShubhCards') {
        var url1 = document.getElementById("shubhcards-tab")
        if (url1 == null) {
          setTimeout(() => {
            this.delayedFunction();
          }, 100);

        }
        else {
          document.getElementById("shubhcards-tab").scrollIntoView();

        }
      }
    });


  }
  delayedFunction() {
    document.getElementById("shubhcards-tab").scrollIntoView();


  }
  scrollToBottom() {
    console.log("test", "test123456789", document.body.scrollHeight)
    this.viewportScroller.scrollToPosition([0, 9911]);
    window.scrollTo(5, 1000)
    console.log("test", "test123456789", document.body.scrollHeight)
  }
  routeToLists(cate) {
    const params = cate.name.split('/').map(param => param.replace(/\s+/g, '-'));
    console.log("URL BBJAH", params)
    this.router.navigate(['/productListing', ...params]); 
   }

  routeToLists1(cate) {
    const params = cate.split('/').map(param => param.replace(/\s+/g, '-'));
    console.log("URL BBJAH", params)
    this.router.navigate(['/productListing', ...params]);  
  }



  routeToList1(category) {
    console.log(category.target.innerText, "categoryvimpro")
    var getcatedata = category.target.innerText.toUpperCase()
    let product_data = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": null,
      "extras": {
        "find": {
          "brand": [],
          "category": [getcatedata],
          "theme": [],
          "finish": [],
          "feature": [],
          "price": [],
          "size": [],
          "thickness": [],
          "color": [],
          "type": [],
          "product_material": [],

          "last90days": false,
          "last30days": false,
          "includeoutofstock": false,
        },
        "pagination": true,
        "paginationDetails": {
          "limit": 0,
          "pagesize": 77
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "name",
          "sortorder": -1
        },
        "subcategoryfilter": false
      }


    }
    this.appService
      .postApiCall(product_data, ENDPOINTS.GET_FILTER_PRODUCTS)
      .subscribe(
        (resp) => {
          this.allproducts1 = resp.result.data.filter(value => { if (value.is_featured_products) { return value; } })
        })

  }

  avonListRouting() {
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });
  }

  schifListRouting(category) {
    // if(category !== "Hair Care" && category !== "Eye Care"){
    this.router.navigate([`/productListing`], { queryParams: { terms: [[], [category], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []], type: 'combine' }, relativeTo: this.route, skipLocationChange: false });
  }
  // }

  getCategory(data) {

    var getcatedata = data.toUpperCase()
    let product_data = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": null,
      "extras": {
        "find": {
          "brand": [],
          "category": [getcatedata],
          "theme": [],
          "finish": [],
          "feature": [],
          "price": [],
          "size": [],
          "thickness": [],
          "color": [],
          "type": [],
          "product_material": [],

          "last90days": false,
          "last30days": false,
          "includeoutofstock": false,
        },
        "pagination": true,
        "paginationDetails": {
          "limit": 0,
          "pagesize": 77
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "name",
          "sortorder": -1
        },
        "subcategoryfilter": false
      }


    }
    this.appService
      .postApiCall(product_data, ENDPOINTS.GET_FILTER_PRODUCTS)
      .subscribe(
        (resp) => {
          this.allproducts1 = resp.result.data.filter(value => { if (value.is_featured_products) { return value; } })
        })

  }
  navCategory
  // topFunction() {
  //   window.scroll(0,2900);
  //   }

  closeModal() {
    console.log("closedclosed")
    this.modalReference.close();
  }
  getCategory1() {
    {
      this.req_filter_data1 = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "extras": {
          "find": {
            "brand": [],
            "category": ["Packaging"],
            "theme": [],
            "finish": [],
            "feature": [],
            "price": [],
            "size": [],
            "thickness": [],
            "color": [],
            "type": [],
            "product_material": [],

            "last90days": false,
            "last30days": false,
            "includeoutofstock": false,
          },
          "pagination": true,
          "paginationDetails": {
            "limit": 0,
            "pagesize": 77
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "name",
            "sortorder": -1
          },
          "subcategoryfilter": false
        }


      }


      this.appService.postApiCall(this.req_filter_data1, ENDPOINTS.GET_FILTER_PRODUCTS).subscribe(
        resp => {
          this.filtersApiData = resp;
          this.ProductsbasedonCategory = this.filtersApiData.result.data;


        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
  }
  getCategory2() {
    {
      this.req_filter_data1 = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "extras": {
          "find": {
            "brand": [],
            "category": ['Disposable Cutlery'],
            "theme": [],
            "finish": [],
            "feature": [],
            "price": [],
            "size": [],
            "thickness": [],
            "color": [],
            "type": [],
            "product_material": [],

            "last90days": false,
            "last30days": false,
            "includeoutofstock": false,
          },
          "pagination": true,
          "paginationDetails": {
            "limit": 0,
            "pagesize": 77
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "name",
            "sortorder": -1
          },
          "subcategoryfilter": false
        }


      }


      this.appService.postApiCall(this.req_filter_data1, ENDPOINTS.GET_FILTER_PRODUCTS).subscribe(
        resp => {
          this.filtersApiData = resp;
          this.ProductsbasedonCategory1 = this.filtersApiData.result.data;



        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
  }
  getPaulround() {
    this.changeactive = true;
    this.changeactive1 = false;
    
      this.req_filter_data1 = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "extras": {
          "find": {
            "brand": [],
            "category": ['Men Round Neck'],
            "theme": [],
            "finish": [],
            "feature": [],
            "price": [],
            "size": [],
            "thickness": [],
            "color": [],
            "type": [],
            "product_material": [],

            "last90days": false,
            "last30days": false,
            "includeoutofstock": false,
          },
          "pagination": true,
          "paginationDetails": {
            "limit": 0,
            "pagesize": 77
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "name",
            "sortorder": -1
          },
          "subcategoryfilter": false
        }


      }


      this.appService.postApiCall(this.req_filter_data1, ENDPOINTS.GET_FILTER_PRODUCTS).subscribe(
        resp => {
          this.filtersApiData = resp;
          this.ProductsbasedonCategory = this.filtersApiData.result.data;

console.log("PaulCaroline YYAJGDK")

        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    
  }
  getPaulpolo() {
    this.changeactive = false;
    this.changeactive1 = true;
    {
      this.req_filter_data1 = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "extras": {
          "find": {
            "brand": [],
            "category": ['Men Polo'],
            "theme": [],
            "finish": [],
            "feature": [],
            "price": [],
            "size": [],
            "thickness": [],
            "color": [],
            "type": [],
            "product_material": [],

            "last90days": false,
            "last30days": false,
            "includeoutofstock": false,
          },
          "pagination": true,
          "paginationDetails": {
            "limit": 0,
            "pagesize": 77
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "name",
            "sortorder": -1
          },
          "subcategoryfilter": false
        }


      }


      this.appService.postApiCall(this.req_filter_data1, ENDPOINTS.GET_FILTER_PRODUCTS).subscribe(
        resp => {
          this.filtersApiData = resp;
          this.ProductsbasedonCategory = this.filtersApiData.result.data[0].variant.option_values[0].child;
          this.poloName = this.filtersApiData.result.data[0].name
          this.poloid = this.filtersApiData.result.data[0].id
          console.log("polotshirts", this.ProductsbasedonCategory)

        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
  }
  subscribe() {
    this.showalertmsg = true;
    if (this.subscribeForm.valid) {
      this.validateForm = false;
      var subscribeFormData = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        "payload": {
          "customerSubcribe": {
            "has_also_subscribed": true,
            "email": this.subscribeForm.value.email
          }
        },
        "extras": {
          "find": {
            "email": this.subscribeForm.value.email
          }
        }

      }
      console.log(subscribeFormData)
      this.appService.postApiCall(subscribeFormData, ENDPOINTS.SUBSCRIBE).subscribe(resp => {
        if (resp) {
          if (resp.success == 1) {
            window.scroll(0, 0);
            this.alertService.success('Subscribed Succesfully!', this.options);

            this.subscribeForm.reset();

          }
          else {
            this.alertService.warn(resp.message, this.options);
          }
        }
      },
        err => {
          if (err.error.message) {
            this.alertService.error(err.error.message, this.options);
          }
          else {
            this.alertService.error('Something bad happened. Please try again!', this.options);
          }
        }
      )
      // }
      // if (this.subscribeForm.valid) {
      //   //this.validateForm = false;


    }
    else {
      this.validateForm = true;
    }

  }
  @ViewChild('videoPlayerDesktop') videoPlayerDesktop: ElementRef;
  @ViewChild('videoPlayerMobile') videoPlayerMobile: ElementRef;
  hideOverlay: boolean = false;

  toggleVideo1() {
    this.hideOverlay = false;

    if (this.videoPlayerMobile && this.videoPlayerMobile.nativeElement) {
      const videoMobile: HTMLVideoElement = this.videoPlayerMobile.nativeElement;
      // Toggle mobile video player state
      if (videoMobile.paused) {
        videoMobile.play();
      } else {
        videoMobile.pause();
      }
      // Update hideOverlay based on mobile video player state
      this.hideOverlay = !videoMobile.paused;
    }
  }

  toggleVideo() {
    // Reset hideOverlay to false to show overlay images and controls
    this.hideOverlay = false;

    // Check if the mobile video player exists


    // Check if the desktop video player exists
    if (this.videoPlayerDesktop && this.videoPlayerDesktop.nativeElement) {
      const videoDesktop: HTMLVideoElement = this.videoPlayerDesktop.nativeElement;
      // Toggle desktop video player state
      if (videoDesktop.paused) {
        videoDesktop.play();
      } else {
        videoDesktop.pause();
      }
      // Update hideOverlay based on desktop video player state
      this.hideOverlay = this.hideOverlay || !videoDesktop.paused;
    }
  }


  ngAfterViewInit() {
    if (this.videoPlayerMobile && this.videoPlayerMobile.nativeElement) {
      const videoPlayerMobile: HTMLVideoElement = this.videoPlayerMobile.nativeElement;

      videoPlayerMobile.addEventListener('play', () => {
        this.hideOverlay = true; // Hide overlay when video starts playing
      });

      videoPlayerMobile.addEventListener('ended', () => {
        this.hideOverlay = false; // Show overlay when video ends playing
      });
    }

    if (this.videoPlayerDesktop && this.videoPlayerDesktop.nativeElement) {
      const videoPlayerDesktop: HTMLVideoElement = this.videoPlayerDesktop.nativeElement;

      videoPlayerDesktop.addEventListener('play', () => {
        this.hideOverlay = true; // Hide overlay when video starts playing
      });

      videoPlayerDesktop.addEventListener('ended', () => {
        this.hideOverlay = false; // Show overlay when video ends playing
      });
    }
    if (this.config.title === 'Schift Cosmetics') {
      setTimeout(() => {
        const elem = document.getElementById("schiftmodalforhomepage");
        if (elem) {
          elem.click();
          console.log("Element clicked:", elem);
        } else {
          console.log("Element not found, ensure it exists in the DOM.");
        }
      }, 0);
    }
  }
  getSubjectEnglish(data) {
    {
      this.req_filter_data1 = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "extras": {
          "find": {
            "brand": [],
            "category": [],
            "theme": [],
            "finish": [],
            "feature": [],
            "price": [],
            "size": [],
            "thickness": [],
            "color": [],
            "type": [],
            "product_material": [],
            "subject": [data],


            "last90days": false,
            "last30days": false,
            "includeoutofstock": false,
          },
          "pagination": true,
          "paginationDetails": {
            "limit": 0,
            "pagesize": 77
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "name",
            "sortorder": -1
          },
          "subcategoryfilter": false
        }


      }


      this.appService.postApiCall(this.req_filter_data1, ENDPOINTS.GET_FILTER_PRODUCTS).subscribe(
        resp => {
          this.filtersApiData = resp;
          if (data == "General English") {
            this.englishBook = this.filtersApiData.result.data.slice(0, 5);
            this.englishBookMobile = this.filtersApiData.result.data.slice(0, 4);
            console.log(this.englishBook, "this.englishBook")

          }
          else {
            this.mathsBook = this.filtersApiData.result.data.slice(0, 5);
            this.mathsBookMobile = this.filtersApiData.result.data.slice(0, 4);
            console.log(this.englishBook, "this.mathsBook")
          }

          // this.totalNumberOfProducts = this.filtersApiData.result.total;
          //  if(!this.isfilter)
          //  {
          //this.isfilter=true;

          // this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;

          // this.totalProducts = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;
          //  this.totalLength = this.filtersApiData.result.total ? this.filtersApiData.result.total : 0;

          // this.totalLength = this.totalItemsOrProducts = this.filtersApiData.result.total.value ? this.filtersApiData.result.total.value : 0;


        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
  }
  goToSection() {
    var id = document.getElementById("bestSellerSri");
    if (id == null) {
      setTimeout(() => {
        this.delayedFunctionNew();
      }, 100)

    }
    else {
      document.getElementById("bestSellerSri").scrollIntoView()

    }

  }
  delayedFunctionNew() {
    document.getElementById("bestSellerSri").scrollIntoView()

  }
  productsListTazTest(){
    document.getElementById("mySidenav").style.width = "0";
    this.router.navigate(['/productListing']);
  }
  productsListTazTest1(category){
    console.log("Category to redirect",category)
    const params = category.split('/').map(param => param.replace(/\s+/g, '-'));
    console.log("URL BBJAH", params)
    this.router.navigate(['/productListing', ...params]);
  }
  productsListBest(category){
    console.log("Category to redirect",category)
    const params = category.name.split('/').map(param => param.replace(/\s+/g, '-'));
    console.log("URL BBJAH", params)
    this.router.navigate(['/productListing', ...params]);
  }
  getCarouseldetails() {

    // REQUEST DATA
    let request_data = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {}
      }
    }
    // MAKE AN API CALL
    this.appService.postApiCall(request_data, ENDPOINTS.STORE_GALLERY).subscribe(  //LINE 
      resp => {
        let respData = resp.result.data[0];
        // console.log(resp)
        if (respData.carousel) {
          if (respData.carousel.slides.length > 0) {
            if (config.title === "HOB") {
              this.carouselData = respData.carousel.slides;
              console.log(this.carouselData.length, " this.carouselData.length")
              this.carouselData.forEach(element => {
                if (element.heading == "mobile") {
                  let mobile_slide = {
                    image_source: element.image_source
                  }
                  this.mobile_images.push(mobile_slide)
                }
                if (element.heading == "desktop") {
                  let desk_slide = {
                    image_source: element.image_source
                  }

                  this.desk_images.push(desk_slide)
                  console.log(this.desk_images, "desk_images")

                }
                if (element.heading == "desktophomebanner1") {
                  let desk_slide = {
                    image_source: element.image_source
                  }

                  this.homebanner1.push(desk_slide)
                  console.log(this.homebanner1, "desk_images")

                }
                if (element.heading == "mobilehomebanner1") {
                  let desk_slide = {
                    image_source: element.image_source
                  }

                  this.mobilehomebanner1.push(desk_slide)
                  console.log(this.mobilehomebanner1, "desk_images")

                }
                if (element.heading == "desktophomebanner2") {
                  let desk_slide = {
                    image_source: element.image_source
                  }

                  this.homebanner2.push(desk_slide)
                  console.log(this.homebanner2, "desk_images")

                }
                if (element.heading == "mobilehomebanner2") {
                  let desk_slide = {
                    image_source: element.image_source
                  }

                  this.mobilehomebanner2.push(desk_slide)
                  console.log(this.mobilehomebanner2, "desk_images")

                }
                console.log("desk_slide", this.carouselData)
              });
            }
          }
        }
      }

      ,

      err => {
        if (err) {
          console.log(err)
        }

        else {
          console.log('Something bad happened; Please try again!')
        }
      })


  }
  getCurrentURL() {
    return window.location.href
  }

  onClick(event) {
    console.log("clickoodjdj",event)
    const imgElem = event.target;
    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;
    this.imgSrc = "https://images-na.ssl-images-amazon.com/images/M/MV5BMTM0MDgwNjMyMl5BMl5BanBnXkFtZTcwNTg3NzAzMw@@._V1_.jpg";
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}




